export default __webpack_public_path__ + "static/dummyRoundTwo-c0563daf009b3fbe9b68e426d4ee6f2a.png";